import { createContext } from 'react'
import { AuthUser } from 'ts/types'
import { RoutesMap } from 'ts/types/common'

export interface AuthContextType {
  user: AuthUser | null
  saveUser: (authData: AuthUser) => void
  clearUser: () => void
  isLoggedIn: () => boolean
  allowedRoutes: RoutesMap
}

export const AuthContext = createContext<AuthContextType | null>(null)
